/* eslint-disable no-undef */
// import { mapGetters } from 'vuex'
var meta = {
  data () {
    return {
      // debug: false
    }
  },
  computed: {
  },
  methods: {
    return_item_2026 (value) {
      if (!value) return []
      const buildItem = (item) => {
        if (!item) return null
        const newItem = {
          id: item.id || '',
          quantity: item.quantity || 1
        }
        return newItem
      }
      return Array.isArray(value)
        ? value.map(item => buildItem(item)).filter(Boolean)
        : [buildItem(value)]
    },
    // meta
    meta_add_to_cart () {
      console.log('meta_add_to_cart')
      fbq('track', 'AddToCart')
    },

    meta_purchase_track (orderData, products) {
      console.log('meta_purchase_track')
      fbq('track', 'Purchase',
        {
          value: Number(this.calcAmount),
          currency: 'TWD',
          contents: this.return_item_2026(products),
          content_type: 'product'
        },
        {
          eventID: orderData.order_id
        }
      )
    },
    // google
    gtag_purchase_track (orderData, products) {
      console.log('gtag_purchase_track')
      if (typeof window.gtag !== 'function') return
      window.gtag('event', 'conversion', {
        send_to: 'AW-17743379847/aqWGCL667MIbEIf72YxC',
        value: Number(this.calcAmount),
        currency: 'TWD',
        transaction_id: orderData.order_id
      })
    },
    gtag_add_to_cart () {
      console.log('gtag_add_to_cart')
      if (typeof window.gtag !== 'function') return
      window.gtag('event', 'conversion', {
        send_to: 'AW-17743379847/LTnVCLLW8cIbEIf72YxC'
      })
    }
  }
}

export default meta
